import React from 'react';
import TablemaintDrawer from './TablemaintDrawer';
import { findTable } from '../../config/dataTables.registry';

/**
 * Standalone edit drawer for an EDI SCAC Map record (cms.edi_scacmap): maps a
 * partner's SS-line text to a CMS SCAC code. Opened by surfaces that hold only a
 * recno — the Pending EDI Orders board, the pro-detail EDI Info modal, and the
 * EDI Order drawer.
 *
 * This is now just the generic <TablemaintDrawer> pointed at the 'edi-scacmap'
 * registry entry, which already declares the whole form: EDI Handle + SS Line as
 * read-only context (showReadOnlyContext) and SCAC as a /cms-lookups/scacs select,
 * matching the TableCfg's editable=['scac']. It previously hand-rolled all of that
 * a second time, purely because the generic drawer could only render inline inside
 * <TablemaintPage> — so the Data Management page and these surfaces could drift.
 */
interface Props {
  recno: number;
  onClose: () => void;
  onSaved: () => void;
}

const EdiScacMapEditDrawer: React.FC<Props> = ({ recno, onClose, onSaved }) => {
  const cfg = findTable('edi-scacmap');
  if (!cfg) return null;
  return (
    <TablemaintDrawer
      cfg={cfg}
      isOpen
      row={null}
      recno={recno}
      title={(r) => `EDI SCAC Map — ${String(r?.scactext ?? '') || `#${recno}`}`}
      width="42rem"
      onClose={onClose}
      onSaved={() => onSaved()}
    />
  );
};

export default EdiScacMapEditDrawer;
